// filepath: src/components/category-chip/index.tsx
import React from "react";
import { StyledChip } from "./styles";

export type CategoryChipProps = {
  label: string;
  selected: boolean;
  onClick?: () => void;
  disabled?: boolean;
  selectionType?: "primary" | "secondary";
  // aceita props extras (ex: aria, className) e event handlers do Tooltip
} & React.ComponentProps<typeof StyledChip>;

export const CategoryChip = React.forwardRef<HTMLDivElement, CategoryChipProps>(
  ({ label, selected, onClick, disabled = false, selectionType, ...rest }, ref) => {
    return (
      <StyledChip
        {...rest}
        ref={ref}
        label={label}
        $selected={selected}
        onClick={onClick}
        disabled={disabled}
        selectionType={selectionType}
        clickable
      />
    );
  }
);

CategoryChip.displayName = "CategoryChip";
export default CategoryChip;